import CadastroInterceptor from '../CadastroInterceptor'

const api = new CadastroInterceptor()

export default {
  getEspecialidades() {
    return api.get(`/cbos`)
  },
  getEspecialidadesMedico(ids: String) {
    return api.get(`/cbos/especialidades?ids=${ids}`)
  }
}
